"use client";

import { ArrowRightLeft, Calendar, CheckCircle, FileText, Users, XCircle } from "lucide-react";
import ProcessFlowchart from "./ProcessFlowchart";

export default function TransitionFlowchart() {
  const studentSteps = [
    { id: 1, title: "Select Academic Years", description: "Choose current year and target (new) academic year", icon: <Calendar className="h-5 w-5" />, color: "bg-blue-500" },
    { id: 2, title: "View Students", description: "Filter students by class or search for specific students", icon: <Users className="h-5 w-5" />, color: "bg-purple-500" },
    { id: 3, title: "Set Results", description: "Mark each student as Pass or Fail", icon: <CheckCircle className="h-5 w-5" />, color: "bg-green-500" },
    { id: 4, title: "Promote Students", description: "Passed students move to next class, failed stay in same class", icon: <ArrowRightLeft className="h-5 w-5" />, color: "bg-yellow-500" },
    { id: 5, title: "Create Enrollments", description: "New enrollments created for target academic year", icon: <FileText className="h-5 w-5" />, color: "bg-indigo-500" },
  ];

  const teacherSteps = [
    { id: 1, title: "Select Academic Years", description: "Choose current year and target academic year", icon: <Calendar className="h-5 w-5" />, color: "bg-blue-500" },
    { id: 2, title: "View Teachers", description: "See all teachers in the system", icon: <Users className="h-5 w-5" />, color: "bg-purple-500" },
    { id: 3, title: "Mark Status", description: "Mark each teacher as Continuing or Not Continuing", icon: <CheckCircle className="h-5 w-5" />, color: "bg-green-500" },
    { id: 4, title: "Copy Assignments", description: "If continuing, assignments are copied to new year", icon: <ArrowRightLeft className="h-5 w-5" />, color: "bg-yellow-500" },
    { id: 5, title: "Update Enrollments", description: "Create new enrollment or mark current as inactive", icon: <FileText className="h-5 w-5" />, color: "bg-indigo-500" },
  ];

  const legend = (
    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">Key Points:</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs text-gray-600">
        <div className="flex items-start gap-2"><CheckCircle className="h-4 w-4 text-green-600 mt-0.5" /><span><strong>Passed Students:</strong> Automatically promoted to next class</span></div>
        <div className="flex items-start gap-2"><XCircle className="h-4 w-4 text-red-600 mt-0.5" /><span><strong>Failed Students:</strong> Remain in same class (repeat)</span></div>
        <div className="flex items-start gap-2"><CheckCircle className="h-4 w-4 text-green-600 mt-0.5" /><span><strong>Continuing Teachers:</strong> Assignments copied to new year</span></div>
        <div className="flex items-start gap-2"><XCircle className="h-4 w-4 text-red-600 mt-0.5" /><span><strong>Not Continuing:</strong> Enrollment marked inactive</span></div>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      <ProcessFlowchart
        title="Student Class Transition Process"
        titleIcon={<Users className="h-5 w-5 text-blue-600" />}
        steps={studentSteps}
        borderClassName="border-gray-200"
      />
      <ProcessFlowchart
        title="Teacher Transition Process"
        titleIcon={<Users className="h-5 w-5 text-purple-600" />}
        steps={teacherSteps}
        borderClassName="border-gray-200"
      />
      {legend}
    </div>
  );
}
